import React, { useCallback, useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Table from "../../../components/Common/Table";
import { useHistory } from "react-router-dom";
import TableFields from "../../../constants/DriverStories/ExternalBrand.json";
import * as DriverStoriesActions from "../../../store/actions/DriverStories";
import ListPagination from "../../../components/Common/ListPagination";
import Permission from "../../../components/Common/Permission";
import { FlexContainer, Heading } from "../../../constants/assets/containers";
import FilterButton from "../../../components/Common/FilterButton";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import { isValNull, debounce } from "../../../utils";
import variables from "../../../constants/assets/variables";
import Back from "sushiweb/Icons/all/Back";
import Breadcrumb from "sushiweb/Breadcrumb";


export function ExternalBrandEntityView(props) {
    const { nextPage, prevPage, getExternalEntitiesList, activeFilters, externalEntitiesList = [] } = props;
    const [externalEntities, setExternalEntities] = useState([]);
    const [modalState, setModalState] = useState(false);
    const allActions = MenuActionsMappings[MenuNames.DRIVER_STORIES];
    const history = useHistory();

    const getFieldValue = (entity_data, key) => {
        return entity_data[key];
    };
    const handleBackClick = () => {
        history.push(`/stories`);
      };
    const ExternalEntitiesListView = () => {
        return (
            <div className="table-container">
            {externalEntities && externalEntities.length > 0 ? (
            <Table
            list={externalEntities}
            getFieldValue={(entity_data, key) => {
                if (key === "previewImageUrl") {
                    return <img src={entity_data[key]} alt="Preview" style={{ width: "100px", height: "100px" }} />;
                }
                return getFieldValue(entity_data, key);
            }}
            fields={TableFields}
              />
            ) : (
            <div>No external brands found.</div>
            )}
            </div>
        );
    };

    const getExternalEntitiesListSync = useCallback(
        debounce(async () => {
          try {
            const data = await getExternalEntitiesList({});
            setExternalEntities(data || []);
          } catch (error) {
            console.error("Error fetching external entities list", error);
            setExternalEntities([]);
          }
        }, 1000),
        []
      );
    
      useEffect(() => {
        getExternalEntitiesListSync();
      }, [getExternalEntitiesListSync]);

    return (
        <Permission requiredParams={[allActions.STORIES_VIEW]}>
            <FlexContainer justify="flex-start">
                &emsp;
                <Back
                    onClick={handleBackClick}
                    className="mr-10 backBtn"
                    color={variables.grey400}
                />
                <Breadcrumb className="sushi-breadcrumbs">
                    <Breadcrumb.Link onClick={handleBackClick}>Stories</Breadcrumb.Link>
                    <Breadcrumb.Link>View all brands</Breadcrumb.Link>
                </Breadcrumb>
            </FlexContainer>
            <div className="container">
                <FlexContainer align="flex-start" className="mb-20">
                    <Heading>&emsp;All External Entities</Heading>
                </FlexContainer>
                <ExternalEntitiesListView />
            </div>
        </Permission>
    );
}

function mapStateToProps(state) {
    const { DriverStories } = state;
    return {
        nextPage: DriverStories.nextPage,
        prevPage: DriverStories.prevPage,
        activeFilters: DriverStories.activeFilters,
        externalEntitiesList: DriverStories.externalEntitiesList,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        resetState: bindActionCreators(DriverStoriesActions.resetState, dispatch),
        getExternalEntitiesList: bindActionCreators(
            DriverStoriesActions.getExternalEntitiesList,
            dispatch
        ),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalBrandEntityView);